import React from 'react'
import Spinner from './Spinner'

interface IconProps {
  height?: number
  children?: React.ReactNode
  squared?: true
  pulse?: boolean
  fullWidth?: true
  isLoading?: boolean
  onClick?: () => void
  dataTestId?: string
  className?: string
  disabled?: boolean
  warning?: true
}

const Button: React.FC<IconProps> = ({
  className,
  height = 32,
  squared,
  children,
  pulse,
  fullWidth,
  isLoading,
  dataTestId,
  onClick,
  disabled = false,
  warning,
}) => {
  return (
    <div
      className={`relative overflow-hidden whitespace-nowrap rounded-sm border-gray-900 ${warning ? 'bg-red-600' : 'bg-zinc-600'} ${fullWidth ? 'w-full' : 'w-fit'} ${className}`}
    >
      <button
        disabled={disabled}
        style={{ minHeight: `${height}px` }}
        onClick={isLoading ? () => {} : onClick}
        {...(dataTestId && { 'data-testid': dataTestId })}
        className={`flex items-center justify-center gap-1 rounded-sm border border-gray-900 text-sm font-semibold text-white disabled:opacity-50 ${pulse && 'animate-[pulse_1s_ease-in-out_infinite]'} ${warning ? 'bg-red-600' : 'bg-zinc-600'} ${squared ? 'aspect-square p-[3px]' : 'px-[15px]'} ${fullWidth ? 'w-full' : 'w-fit'} ${isLoading ? 'opacity-0' : warning ? 'hover:bg-red-500' : disabled ? 'hover:bg-zing-600' : 'hover:bg-zinc-500'}`}
      >
        {children}
      </button>
      {isLoading && (
        <div
          className={`${squared ? 'aspect-square p-[3px]' : 'px-[15px] py-[6px]'} absolute left-0 top-0 flex h-full w-full items-center justify-center`}
        >
          <Spinner className="aspect-square h-full" />
        </div>
      )}
    </div>
  )
}

export default React.memo(Button)
